import ParametrosProvider from "../providers/parametros-provider";
import TokenProvider from "../../commons/providers/token-provider";

class ParametrosRepository {
    
    constructor() {
        this.parametrosProvider = new ParametrosProvider();
        this.tokenProvider = new TokenProvider();
    }

    getParametrosSimulacion = async () => {
        await this.tokenProvider.getToken();
        return this.parametrosProvider.getParametrosSimulacion();
    }

}

export default ParametrosRepository;